<div class="modal-header d-flex justify-content-between">
  <h6 class="modal-title">
    View Document
  </h6>
  <div class="d-flex align-items-center">
    <button type="button" class="btn btn-primary btn-sm" style="margin-right: 20px;" (click)="onDownload()">
      <i class="fa fa-download mr-1"></i> Download
    </button>
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>
@if (doc) {
  <div class="modal-body image-container">
    <img [src]="doc" class="document-image" />
  </div>
}